import axios from '../axios/axios.js';
import router from '@/router';

export default {
    namespaced: true,
    state: {
        isAuthenticated:false,
        userProfile:'',
        activeNav:'dashboard',
        tracker:'',
        lineCount:'',
        activeMonth:'',
        activeAuditor:'',
    },
    getters: {
        isAuthenticated: state => state.isAuthenticated,
        userProfile: state => state.userProfile,
        activeNav: state => state.activeNav,
        activeMonth: state => state.activeMonth,
        activeAuditor: state => state.activeAuditor,
        validateTracker: state => state.tracker,
        totalLineCount: state => state.lineCount,
    },
    actions: {
        async checkAuthenticated({commit},value) {
            await commit('setAuthenticated', value)
        },
        async validateTracker({commit},value) {
            await commit('setTracker', value)
        },
        async setAcitveNav({commit},value) {
            await commit('setNavigation', value)
        },
        async setActiveMonth({commit},value) {
            await commit('setMonth', value)
        },
        async setActiveAuditor({commit},value) {
            await commit('setAuditor', value)
        },
        async setTotalLineCount({commit}) {
            await axios.get(`/api/timetracker/`,{
                headers: {'Authorization' : `Bearer ${localStorage.getItem('token')}`}
            })
            .then( response => {
                commit('setlineCount', response.data.total_linecount)
            })
        },
        async LogIn({commit}, response) {
            localStorage.setItem('token',response.data.access_token);
            localStorage.setItem('isLoggedIn',true);
            commit('setAuthenticated', true)
            commit('setNavigation', 'dashboard')
            await axios.get('api/user',{
                headers: {
                    "Authorization": "Bearer "+ response.data.access_token
                }
            }).then(profile => {   
                commit("setProfile", profile.data)
                router.push({ name: 'Dashboard' });
            })

        },
        async LogOut({commit}){
            await axios.post('api/logout', null,{
                headers: {
                    "Authorization": "Bearer "+ localStorage.getItem("token")
                }
            }).then(response => {             
                localStorage.removeItem('vuex')    
                localStorage.removeItem('token') 
                localStorage.setItem('isLoggedIn',false);
                commit("setAuthenticated", false)
                router.push('/login')
            })             
        },
    },
    mutations: {
        setAuthenticated: (state, status) => (state.isAuthenticated = status),
        setNavigation: (state, status) => (state.activeNav = status),
        setMonth: (state, month) => (state.activeMonth = month),
        setAuditor: (state, auditor) => (state.activeAuditor = auditor),
        setProfile: (state, status) => (state.userProfile = status),
        setTracker: (state, tracker) => (state.tracker = tracker),
        setlineCount: (state, lineCount) => (state.lineCount = lineCount),
    }
}

